module.exports = __webpack_public_path__ + "static/media/AYS.38ee12de.jpg";